import { Card, CircularProgress, Divider, Grid, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import React, { useState } from "react";
import {
  BooleanInput,
  Button,
  FileField,
  FileInput,
  NumberInput,
  required,
  SelectInput,
  TextInput,
  Toolbar,
  useDataProvider,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { CustomDatetime } from "../../Components/CustomDatetime";
import { SectionTitle } from "../../Components/SectionTitle";
import { Separator } from "../../Components/Separator";
import { useAppDataProvider } from "../../dataprovider";
import { RequestExcusableStatus } from "../../Enums/RequestExcusableStatus";
import { ExcusableHistoryCreateModel } from "../RequestOrder/Models/ExcusableHistoryCreateModel";
import { excusableStatus, excusableTypes, shippingTypes, SourceExcusable, SourceExcusableRbh } from "./Constant/Source";
import ExcusableHistory from "./ExcusableHistory";
import { RequestExcusableShippingType } from "../../Enums/RequestExcusableShippingType";
import { DownloadButton, useAuth } from "@airborne/react-admin";
import { FileAcceptWhiteList } from "../../Constants/Constant";
import { useLocation } from "react-router-dom";
import { RequestExcusableOrderType } from "../../../src/Enums/RequestExcusableOrderType";
const useStyles = makeStyles(theme => ({
  toolbar: {
    display: "flex",
    justifyContent: "end",
  },
  gridItem: {
    margin: "0px 10px",
  },
}));

export const ExcusableDetail = props => {
  const classes = useStyles(props);
  const provider = useDataProvider();
  const history = useHistory();
  const Dataprovider = useAppDataProvider();
  const [fileList, setFileList] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const [partiallyIsShow, setPartiallyIsShow] = useState(false);
  const [requestOrderType, setRequestOrderType] = useState<string | undefined>(undefined);
  const [data, setData] = useState({} as any);
  const [fileRelationUploading, setFileRelationUploading] = useState(false);
  const notify = useNotify();
  const { user } = useAuth();
  const location = useLocation();

  React.useEffect(() => {
    const query = new URLSearchParams(location.search);
    const sourceRequestOrderType =
      query.get("requestType") == RequestExcusableOrderType.Pbh.toString() ? SourceExcusable : SourceExcusableRbh;
    const requestTypeValue = query.get("requestType");
    setRequestOrderType(requestTypeValue ?? undefined);
    provider
      .getOne(sourceRequestOrderType, {
        id: props.id,
      })
      .then(response => {
        setData(response.data);
      })
      .catch(error => {});
  }, []);

  const handleFileChange = async fileObj => {
    let file: File = fileObj[0];
    const {
      data: { objectKey },
    } = await Dataprovider.uploadFileMinio(file);
    var tempFiles = fileList;
    tempFiles.push({ id: 0, name: file.name, objectKey: objectKey });
    setFileList([...tempFiles]);
  };

  const handleCreateFileRelation = async form => {
    const formData = form?.getState?.()?.values ?? {};

    if (fileList.length === 0) {
      notify("No files available to create relation", "warning", false, true);
      return;
    }

    setFileRelationUploading(true);
    try {
      // Create the excusable history payload with file relations
      const excusableHistoryPayload = {
        RequestOrderExcusableId: props?.id,
        Description: formData?.description,
        AgreementRef: formData?.agreementRef,
        Remark: formData?.remark,
        Status: formData?.status,
        PartiallyAcceptedDays: formData?.partiallyAcceptedDays,
        Files: fileList,
      };

      await Dataprovider.postRequestExcusableHistory(excusableHistoryPayload);
      notify("Excusable history with file relation created successfully", "success", false, true);
      history.go(0);
    } catch (error) {
      notify(`Error creating excusable history: ${error}`, "error", false, true);
    } finally {
      setFileRelationUploading(false);
    }
  };

  const handleHistory = (status, form) => e => {
    const formData = form?.getState?.()?.values ?? {};
    // if (Validation(formData, status)) {
    //   return
    // }

    // Remark is only mandatory when moving from Rejected to Under Dispute (the "Dispute" action).
    const isRemarkRequired = status === RequestExcusableStatus.UnderDispute;
    const isRemarkMissing = !formData?.remark || formData.remark === "";
    setValidation(prevValidation => ({ ...prevValidation, remark: isRemarkRequired && isRemarkMissing }));
    if (isRemarkRequired && isRemarkMissing) {
      notify("Remark is required to move the record to Under Dispute", "warning", false, true);
      return;
    }

    setLoading(true);
    var requestModel: ExcusableHistoryCreateModel = new ExcusableHistoryCreateModel();
    requestModel.AgreementRef = formData?.agreementRef;
    requestModel.Description = formData?.description;
    requestModel.Remark = formData?.remark;
    requestModel.RequestOrderExcusableId = props?.id;
    requestModel.PartiallyAcceptedDays = formData?.partiallyAcceptedDays;
    requestModel.Status = status;
    requestModel.Files = fileList;

    Dataprovider.postRequestExcusableHistory(requestModel)
      .then(result => {
        requestOrderType == RequestExcusableOrderType.Pbh.toString()
          ? history.push("/excusable/pbh")
          : history.push("/excusable/rbh");
        notify(`Record created`, "success", false, true);
      })
      .catch(error => {
        notify(`${error}`, "error", false, true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePartiallyAcceptedChange = e => {
    setPartiallyIsShow(e);
  };

  const [validation, setValidation] = useState({
    agreementRef: false,
    description: false,
    partiallyAcceptedDays: false,
    remark: false,
  } as any);
  const Validation = (values, status) => {
    var tempValidation = { ...validation };
    tempValidation.agreementRef = !values.agreementRef || values.agreementRef == "" ? true : false;
    tempValidation.description = !values.description || values.description == "" ? true : false;
    tempValidation.partiallyAcceptedDays =
      status === RequestExcusableStatus.PartiallyAccepted && values.partiallyAcceptedDays === null ? true : false;
    setValidation({ ...tempValidation });
    if (tempValidation.agreementRef || tempValidation.description || tempValidation.partiallyAcceptedDays) {
      return true;
    }
    return false;
  };
  return (
    <Form
      initialValues={data}
      onSubmit={() => {}}
      render={({ handleSubmit, form, values }) => {
        return (
          <form>
            <Card>
              <Grid container spacing={0} style={{ padding: 25 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <SectionTitle label="Order Info" />
                  <Divider style={{ padding: 0 }} />
                  <Separator />
                </Grid>
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <TextInput source="refNo" label="Ref No" fullWidth disabled variant="outlined" />
                  <TextInput source="customerCode" label="Customer" fullWidth disabled variant="outlined" />
                  <TextInput source="melCategory" label="Category" fullWidth disabled variant="outlined" />
                  <TextInput source="pn" label="PN" fullWidth disabled variant="outlined" />
                  <TextInput source="sn" label="SN" fullWidth disabled variant="outlined" />
                  <CustomDatetime
                    source="requestedDeliveryDate"
                    label="Requested Delivery Date"
                    fullWidth
                    showTime
                    disabled
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={1} />
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <SelectInput
                    source="shippingType"
                    choices={shippingTypes}
                    optionText="label"
                    optionValue="id"
                    disabled
                    fullWidth
                    variant="outlined"
                  />

                  <SelectInput
                    source="status"
                    label="Excusable Delay Status"
                    choices={excusableStatus}
                    optionText="label"
                    optionValue="id"
                    fullWidth
                    disabled
                    variant="outlined"
                  />

                  <CustomDatetime
                    source="flightDate"
                    label="Forward Date to Carrier"
                    fullWidth
                    showTime
                    disabled
                    variant="outlined"
                  />
                  <CustomDatetime
                    source="estimatedDeliveryDate"
                    label="Estimated Delivery Date"
                    fullWidth
                    showTime
                    disabled
                    variant="outlined"
                  />
                  <CustomDatetime
                    source="coreDueDate"
                    label="Core Due Last Date"
                    fullWidth
                    showTime
                    disabled
                    variant="outlined"
                  />
                  <SelectInput
                    source="type"
                    choices={excusableTypes}
                    defaultValue={data.type}
                    optionText="label"
                    optionValue="id"
                    fullWidth
                    variant="outlined"
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <TextInput
                    source="remark"
                    label="Remark"
                    fullWidth
                    multiline
                    minRows={2}
                    variant="outlined"
                    error={validation.remark}
                    helperText={validation.remark ? "Remark is required to move to Under Dispute" : undefined}
                  />
                </Grid>
                {values.status !== RequestExcusableStatus.Accepted && (
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Separator />
                    <Separator />
                    <SectionTitle label="Excusable Detail" />
                    <Divider />
                    <Separator />
                  </Grid>
                )}
                {values.status !== RequestExcusableStatus.Accepted && (
                  <Grid item xs={12} sm={12} md={5} lg={5}>
                    <TextInput
                      source="agreementRef"
                      label="Agreement Article Reference"
                      fullWidth
                      validate={required()}
                      variant="outlined"
                    />
                    <FileInput
                      style={{ disabled: false }}
                      source="src"
                      label={props.label}
                      multiple={props.multiple}
                      options={{ onDrop: fileObj => { handleFileChange(fileObj); } }}
                      validate={required()}
                      RaFileInput={false}
                      accept={FileAcceptWhiteList}
                    >
                      <FileField source="src" title="title" />
                    </FileInput>

                    {/* Create File Relation Button - Only visible when status is opened or reopened */}
                    {(values.status === RequestExcusableStatus.Opened ||
                      values.status === RequestExcusableStatus.UnderDispute) && (
                      <div style={{ marginTop: "16px" }}>
                        <Button
                          label={fileRelationUploading ? "Creating History..." : "Create Excusable History"}
                          disabled={!form.getState().valid || fileRelationUploading || fileList.length === 0}
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={() => handleCreateFileRelation(form)}
                          style={{ margin: "8px 0" }}
                        >
                          {fileRelationUploading ? <CircularProgress size="1rem" color="secondary" /> : <Add />}
                        </Button>
                        {fileList.length === 0 && (
                          <div style={{ fontSize: "0.875rem", color: "#666", marginTop: "4px" }}>
                            Upload a file first to create history
                          </div>
                        )}
                      </div>
                    )}

                    {fileList.map(file => {
                      return (
                        <DownloadButton target={`download/${file.objectKey}`} buttonText={file.name} variant="text" />
                      );
                    })}
                  </Grid>
                )}
                <Grid item xs={12} sm={12} md={2} lg={1} />
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  {user?.isCustomer === false && (
                    <>
                      <BooleanInput
                        label="Is Partially Accepted"
                        source="isPartiallyAccepted"
                        disabled={
                          ((values.status === RequestExcusableStatus.Opened ||
                            values.status === RequestExcusableStatus.UnderDispute) &&
                            data.shippingType !== RequestExcusableShippingType.Serviceable) === false
                        }
                        onChange={e => handlePartiallyAcceptedChange(e)}
                      />
                      {partiallyIsShow && (
                        <NumberInput
                          source="partiallyAcceptedDays"
                          label="Partially Accepted Days"
                          fullWidth
                          showTime
                          variant="outlined"
                          validate={validation.partiallyAcceptedDays == true ? required() : []}
                        />
                      )}
                    </>
                  )}
                  {values.status !== RequestExcusableStatus.Accepted && (
                    <TextInput
                      source="description"
                      label="Description"
                      fullWidth
                      multiline
                      minRows={4}
                      validate={required()}
                      variant="outlined"
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4}></Grid>
              </Grid>
              <Toolbar {...props} placeholder="" className={classes.toolbar}>
                {values.status === RequestExcusableStatus.Rejected && (
                  <Button
                    label={loading ? "Creating!" : "Dispute"}
                    disabled={loading}
                    size="medium"
                    variant="contained"
                    color="primary"
                    onClick={handleHistory(RequestExcusableStatus.UnderDispute, form)}
                  >
                    {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                  </Button>
                )}
                {((values?.shippingType === RequestExcusableShippingType.Serviceable && user?.isCustomer) ||
                  (values?.shippingType === RequestExcusableShippingType.Unserviceable && user?.isCustomer == false)) &&
                  (values.status === RequestExcusableStatus.Opened ||
                    values.status === RequestExcusableStatus.UnderDispute) && (
                    <>
                      <Button
                        label={loading ? "Accepting!" : "Accept"}
                        disabled={loading}
                        size="medium"
                        variant="contained"
                        onClick={handleHistory(RequestExcusableStatus.Accepted, form)}
                        style={{ margin: "8px", background: "seagreen" }}
                      >
                        {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                      </Button>
                      <Button
                        label={loading ? "Rejecting!" : "Reject"}
                        disabled={loading}
                        size="medium"
                        variant="contained"
                        style={{ margin: "8px" }}
                        color={"primary"}
                        onClick={handleHistory(RequestExcusableStatus.Rejected, form)}
                      >
                        {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                      </Button>
                      {!user?.isCustomer && (
                        <Button
                          label={loading ? "Accepting!" : "Partially Accept"}
                          disabled={loading}
                          size="medium"
                          variant="contained"
                          style={{ margin: "8px", background: "#ffc107" }}
                          onClick={handleHistory(RequestExcusableStatus.PartiallyAccepted, form)}
                        >
                          {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                        </Button>
                      )}
                    </>
                  )}
              </Toolbar>

              {values.id > 0 && (
                <Grid style={{ padding: "10px 25px" }} container spacing={0}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SectionTitle label="Excusable History List" />
                    <Divider style={{ padding: 0 }} />
                    {values.id > 0 && <ExcusableHistory requestOrderExcusableId={values.id} />}
                  </Grid>
                </Grid>
              )}
            </Card>
          </form>
        );
      }}
    ></Form>
  );
};
export default ExcusableDetail;
